import type { IconSvgObject } from './types';

const ShoppingBasketSecure01Icon: IconSvgObject = [
  ["path", { d: "M13 22H6C4.34315 22 3 20.6569 3 19V8.5C3 7.67157 3.67157 7 4.5 7H17.5C18.3284 7 19 7.67157 19 8.5V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 9.5C15 5.63401 13.2091 2 11 2C8.79086 2 7 5.63401 7 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 16.05C20.2929 15.4095 19.2117 15 18 15C16.7883 15 15.7071 15.4095 15 16.05V18.15C15 20.95 18 22 18 22C18 22 21 20.95 21 18.15L21 16.05Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ShoppingBasketSecure01Icon;
